import { defineStore } from 'pinia'

export const useAlert = defineStore('alert', {
    state: () => {
        return {
            type: 'info',
            title: '',
            text: '',
            confirmButton: null,
            confirmClass: null,
            cancelButton: null,
            cancelClass: null,

            openDialog: false,
            confirm: false,
            timeout: null,
            allowedTypes: ['success', 'warning', 'danger', 'info'],
        };
    },

    actions: {
        show(options) {
            this.$reset();
            this.type = options['type'];
            this.title = options['title'];
            this.text = options['text']?options['text']:'';
            this.confirmButton = options['confirmButton']?options['confirmButton']:null;
            this.confirmClass = options['confirmClass']?options['confirmClass']:null;
            this.cancelButton = options['cancelButton']?options['cancelButton']:null;
            this.cancelClass = options['cancelClass']?options['cancelClass']:null;
            this.confirmClass = options['confirmClass'];

            this.$patch({openDialog: true});
            this.confirm = false;
            this.timeout = options['timeout']?options['timeout']:null
        },

        hide() {
            this.$patch({openDialog: false});
            this.$reset();
        }
    }
})